import React, { Component } from 'react' // PropTypes
import CSSModules from 'react-css-modules'
// import {Row, Col} from 'react-flexindex-grid'
import format from '../../helpers/format'
import config from '../../config'
import {
  Link,
} from '../../components'
import Styles from './BenchmarkGridTable.css'


@CSSModules(Styles,{allowMultiple:true})
export default class BenchmarkGridTable extends Component {
  // static propTypes = {
  //   gradeField: PropTypes.string.isRequired,
  //   gradeName:  PropTypes.string.isRequired
  // }

  constructor(props){
    super(props)
    this.state = {
      sortedBenchmarks: this.sortBenchmarks()
    }
  }

  // sort benchmarks by set order
  sortBenchmarks = () => {
    const indxs = {
      'S&P 500': 0,
      'Russell 1000': 1,
      'Russell 2000': 2,
      'Russell 3000': 3,
      'S&P 100': 4,
      'Russell Top 200': 5,
      'MSCI ACWI': 6,
      'MSCI EAFE': 7,
      'MSCI Emerging Markets': 8,
      'MSCI ACWI ex U.S.': 9,
    }
    const sorted = Array.apply(null, Array(10)).map((x, i) => { return null; })
    const benchmarks = [].concat(
      config.coreBenchmarks.concat(config.extendedBenchmarks))

    for (let i = 0; i<benchmarks.length; i++){
      if (indxs.hasOwnProperty(benchmarks[i].index_name)){
        sorted[indxs[benchmarks[i].index_name]] = benchmarks[i]
      }
    }
    return sorted
  }

  // convert the int grade to a letter
  convertToLetter = (intGrade) => {
    return {
      1: 'A',
      2: 'B',
      3: 'C',
      4: 'D',
      5: 'F',
    }[intGrade] || 'N/A'
  }

  // convert the int grade to a string for styles
  convertToString = (intGrade) => {
    return {
      1: '1',
      2: '2',
      3: '3',
      4: '4',
      5: '5',
    }[intGrade] || '0'
  }

  //
  render() {
    return <table styleName='index-table'>
      <thead>
        <tr>
          <th>
            Index
          </th>
          <th>
            Rated as
          </th>
          <th>
            Gender equality
          </th>
          <th>
            Diversity disclosures
          </th>
          <th>
            Racial justice
          </th>
          <th>
            LGBTQ+ equity
          </th>
        </tr>
      </thead>
      <tbody>
        {
          this.state.sortedBenchmarks.map((b, i) => {
            // build route for this benchmark
            const sName = format.sanitize(b.fund_legal_name)
            const sTicker = b.ticker || 'N'
            const url =
              config.routes.fund + '/' +
              sName + '/' +
              sTicker + '/' + config.profilePath + '/' +
              b.fund_id + '/' +
              b.investment_vehicle_id

            //
            return <tr key={i}>

              <td styleName='index-title'>
                <Link
                  to={url}
                  styleName='index-link'
                  title={b.fund_legal_name}
                >
                  { b.index_name }
                </Link>
              </td>

              <td styleName='index-subtitle'>
                <Link to={url} title={b.fund_legal_name} >
                  { b.ticker }
                </Link>
              </td>

              <td styleName={'index-grade-wrap index-grade-wrap-'+this.convertToString(b.grade_gender_equality)}>
                <Link
                  to={url}
                  title={b.fund_legal_name}
                >
                  {this.convertToLetter(b.grade_gender_equality)}
                </Link>
              </td>

              <td styleName={'index-grade-wrap index-grade-wrap-'+this.convertToString(b.grade_dei)}>
                <Link to={url} title={b.fund_legal_name} >
                  {this.convertToLetter(b.grade_dei)}
                </Link>
              </td>

              <td styleName={'index-grade-wrap index-grade-wrap-'+this.convertToString(b.grade_rji)}>
                <Link to={url} title={b.fund_legal_name} >
                  {this.convertToLetter(b.grade_rji)}
                </Link>
              </td>

              <td styleName={'index-grade-wrap index-grade-wrap-'+this.convertToString(b.grade_hrc)}>
                <Link to={url} title={b.fund_legal_name} >
                  {this.convertToLetter(b.grade_hrc)}
                </Link>
              </td>

            </tr>
          })
        }
      </tbody>
    </table>
  }
}
